import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';

export interface LgpdRequest {
  id: string;
  tipo: 'remocao' | 'dados' | 'retificacao';
  usuarioNome: string;
  usuarioEmail: string;
  fornecedorId?: string;
  fornecedorNome?: string;
  motivo?: string;
  status: 'pendente' | 'aprovado' | 'rejeitado' | 'processado';
  criadoEm: string;
  processadoEm?: string;
  processadoPor?: string;
}

@Injectable({ providedIn: 'root' })
export class LgpdService {
  constructor(private api: ApiService) {}

  listRequests(page = 1, pageSize = 20, status?: string): Observable<{ data: LgpdRequest[]; meta: any }> {
    // Updated to match API_QUICK_REFERENCE.md - admin endpoint
    const params: any = { page, pageSize };
    if (status) params.status = status;
    return this.api.get('/admin/lgpd/removal-requests', params) as Observable<any>;
  }

  approveRequest(id: string, adminNotes?: string): Observable<any> {
    // Updated to match API_QUICK_REFERENCE.md - POST method for admin endpoint
    return this.api.post(`/admin/lgpd/removal-requests/${id}/approve`, { adminNotes });
  }

  rejectRequest(id: string, adminNotes: string): Observable<any> {
    // Updated to match API_QUICK_REFERENCE.md - POST method for admin endpoint
    return this.api.post(`/admin/lgpd/removal-requests/${id}/reject`, { adminNotes });
  }

  getRequestDetails(id: string): Observable<LgpdRequest> {
    // Updated to match API_QUICK_REFERENCE.md - admin endpoint
    return this.api.get<LgpdRequest>(`/admin/lgpd/removal-requests/${id}`);
  }
}
